import type { IconData } from '@stacksjs/iconify-core'

export const contentGlasses: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 3a3 3 0 0 1 6 0H3v5h10V3h-3a3 3 0 1 1 6 0v9a4 4 0 0 1-8 0a4 4 0 0 1-8 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentGlasses
